export default __webpack_public_path__ + "static/media/CircularXXWeb-Book.39e21067.woff2";